import { filterSavedFeedbacksBranchWise } from "../../util/filterSavedFeedbacks";
import { getActiveBranchIds1 } from "../../util/multipleBranch/getActiveBranchId";
import optionBasedFilter from "../../util/optionBasedFilter";
import ratingFilteration from "../../util/ratingFilteration";
import classes from "./FeedbackFilter.module.css";
import { useState } from "react";
export default function FeedbackFilter({ data, setFilteredFeedbackData }) {
  const qdata = JSON.parse(localStorage.getItem("questions"));

  const [options, setOptions] = useState([]);
  const [questionTitle, setQuestionTitle] = useState("All");
  const [ratingFilter, setRatingFilter] = useState("5-");

  function questionSelectHandler(e) {
    let chosenQuestionIndex = e.target.value;
    let questionTitle = "All";
    //setting appropriate options of the question chosen from index.
    if (chosenQuestionIndex == "99") {
      setOptions([]);
    } else {
      let optionsArr = qdata.optionQuestions[chosenQuestionIndex].options;
      let questionTitle = qdata.optionQuestions[chosenQuestionIndex].title;
      console.log(questionTitle);
      let optionsObjectArray = [];
      optionsArr.forEach((option, index) => {
        let obj = {
          optionTitle: option,
          index,
          pressed: false,
        };
        optionsObjectArray.push(obj);
      });
      setOptions(optionsObjectArray);
      setQuestionTitle(questionTitle);
    }
  }

  function fetchButtonHandler() {
    document.getElementById("fetchButton").innerHTML = "Done";
    setTimeout(() => {
      document.getElementById("fetchButton").innerHTML = "Fetch Again";
    }, 1000);
    filterFeedbackData();
  }
  function optionChooseHandler(e) {
    // console.log(e.target.id);
    let optionIndex = e.target.id;

    setOptions((prev) => {
      const newState = prev.map((option, index) => {
        if (option.index == optionIndex) {
          let obj = { ...option, pressed: !option.pressed };
          return obj;
        }
        return option;
      });
      return newState;
    });
  }

  function ratingFilterHandler(e) {
    //console.log("rating changed");
    let v = e.target.value;
    //console.log(v);
    setRatingFilter(v);
  }

  function filterFeedbackData() {
    // filteration happens in 2 stages 1. rating filter 2. questionS Answereed bases.

    // doint rating based filteration of incoming data

    const d1 = ratingFilteration(data, ratingFilter);

    //if user want all feedback no options based filteration
    if (options.length == 0) {
      // we need to filter data into branch wise data.
      const activeBranches = getActiveBranchIds1();

      const d3 = filterSavedFeedbacksBranchWise(d1, activeBranches);
      setFilteredFeedbackData(d3);
      return;
    }

    // doing option based filteration.
    let questionAnswerObject = { questionTitle, optionsSelected: options };
    // console.log(questionAnswerObject);

    const d2 = optionBasedFilter(d1, questionAnswerObject);

    // we need to filter data into branch wise data.
    const activeBranches = getActiveBranchIds1();

    const d3 = filterSavedFeedbacksBranchWise(d2, activeBranches);

    // passing the filtered data back to parent component after filteration.
    setFilteredFeedbackData(d3);
  }
  return (
    <div className={classes.feedbackFilterContainer}>
      <h4>Feedback Selector</h4>
      <div className={classes.ratingFilterContainer}>
        <p>Rating Filter</p>
        <div className={classes.ratingFilter}>
          <select
            defaultValue="ALL"
            name="range"
            id="cars"
            onChange={(e) => ratingFilterHandler(e)}
          >
            <option value="5-">All</option>
            <option value="5*">5 Star</option>

            <option value="4+">4 & above</option>
            <option value="4*">4 Star</option>
            <option value="4-">4 & below</option>
            <option value="3+">3 & above</option>
            <option value="3*">3 Star</option>
            <option value="3-">3 & below</option>
            <option value="2+">2 & above </option>
            <option value="2*">2 Star</option>
            <option value="2-">2 & below</option>

            <option value="1*">1 Star</option>
          </select>
        </div>
      </div>
      <div className={classes.QuestionFilterContainer}>
        <div className={classes.questionFilter}>
          <select
            defaultValue="ALL"
            name="range"
            id="cars"
            onChange={(e) => questionSelectHandler(e)}
          >
            <option value={`99`}>All questions</option>
            {qdata.optionQuestions.map((question, index) => {
              return (
                <option value={`${index}`} key={`${index}bbb`}>
                  {question.title}
                </option>
              );
            })}
          </select>
        </div>
        <div className={classes.optionsContainer}>
          {options.map((item, index) => {
            return (
              <div
                id={`${index}`}
                className={` ${
                  item.pressed ? classes.checkedOption : classes.uncheckedOption
                }`}
                onClick={(e) => optionChooseHandler(e)}
                key={`${index}lll`}
              >
                {item.optionTitle}
              </div>
            );
          })}
        </div>
      </div>

      <div className={classes.fetchButtonContainer}>
        <div
          id={"fetchButton"}
          className={classes.fetchButton}
          onClick={() => {
            fetchButtonHandler();
          }}
        >
          Fetch Feedbacks
        </div>
      </div>
    </div>
  );
}
